<template>
  <div id="app" :class="currentTheme">
    <router-view />
     <AccesibilityBar v-if="!this.session || !this.session.user || this.session.user.groups.length === 0" />
  </div>
</template>
<script>
import updateChecker from "@/utils/updateChecker";
import AccesibilityBar from './components/UI/AccesibilityBar.vue';

export default {
  components: ["AccesibilityBar"],
  data() {
    return {
      currentTheme: localStorage.getItem("theme") || "",
    };
  },
  created() {
    updateChecker.startUpdateCheck();
  },
  computed: {
    session: function () {
      return this.$store.state.session;
    },
  },
};
</script>
<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.grecaptcha-badge {
  width: 70px !important; /* Ancho inicial (colapsado) */
  overflow: hidden !important; /* Oculta el contenido que no cabe */
  transition: all 0.3s ease !important; /* Animación suave */
  border-radius: 3px !important;
  box-shadow: 0 0 10px #888 !important;
  bottom: 4px !important;
  left: 0px !important;
  right: auto !important;
}

.grecaptcha-badge:hover {
  width: 256px !important; /* Ancho al pasar el cursor (expandido) */
}
</style>
